import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, LOCALE_ID, Optional } from '@angular/core';
import { CsHttpClientService } from '@cbuild/cs-common-data-services';
import { map, Observable, ReplaySubject, take } from 'rxjs';
import { ProfileInfo } from './models/profile-info.model';
import { BaseUrlService } from './base-url.service';

function hexToRGB(hex: string): { r: number; g: number; b: number } {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
}

// export type PropertiesList = Array<Property>;

// export interface Property {
//   label: string;
//   value: number;
//   propertyTypeId: PropertyType;
// }
/**
 * @dynamic
 */

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  private _userInfo: ReplaySubject<ProfileInfo> = new ReplaySubject(1);
  public basicInfo: ProfileInfo | undefined;

  constructor(
    private baseUrlService: BaseUrlService,
    private http: CsHttpClientService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(LOCALE_ID) @Optional() public locale: string
  ) {}

  public loadBasicInfo(): void {
    this.http
      .read<Array<ProfileInfo>>(
        'api/account/basic-info/get',
        this.baseUrlService.getApiBaseURL()
      )
      .pipe(
        map(res => res[0]),
        take(1)
      )
      .subscribe(resp => {
        this.basicInfo = resp;
        this.setUserInfo(resp);
      });
  }

  public get $userInfo(): Observable<ProfileInfo> {
    return this._userInfo.asObservable();
  }

  /**
   * sets user profile info
   */
  public setUserInfo(userInfo: ProfileInfo): void {
    if (userInfo) {
      this.basicInfo = { ...this.basicInfo, ...userInfo };
      this._userInfo.next(this.basicInfo);
      return;
    }
    throw new Error('userInfo is required');
  }

  public updateTheme(primary: string, secondary: string): void {
    this.document.documentElement.style.setProperty(
      '--cs-primary-color',
      primary
    );
    this.document.documentElement.style.setProperty(
      '--cs-secondary-color',
      secondary
    );
    {
      const { r, g, b } = hexToRGB(primary);
      this.document.documentElement.style.setProperty(
        '--cs-primary-rgb',
        `${r}, ${g}, ${b}`
      );
    }
    {
      const { r, g, b } = hexToRGB(secondary);
      this.document.documentElement.style.setProperty(
        '--cs-secondary-rgb',
        `${r}, ${g}, ${b}`
      );
    }
  }
}
